import { Routes } from '@angular/router';
import { AuthChildGuard, AuthGuard } from '@core/guards/auth.guard';
import { LayoutComponent } from '@layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthChildGuard],
    loadChildren: () => import('@layout/layout.routes').then((r) => r.layoutRoutes),
  },
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.routing').then((r) => r.AuthRouting),
  },
  {
    path: '404',
    loadComponent: () => import('@features/not-found/not-found.component').then((c) => c.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: '/404',
    pathMatch: 'full',
  },
];
